import React from 'react'
import AppDevelopmentTypePage from './AppDevelopmentTypePage'
import { appDevelopmentTypeContent } from './appDevelopmentTypeContent'

const TravelAppDevelopment = () => <AppDevelopmentTypePage content={appDevelopmentTypeContent.travel} />

export default TravelAppDevelopment
